var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTriangle = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 8,
  viewBox: "0 0 16 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16 0H0L8 8L16 0Z",
  fill: "#FDA700"
})));
export { SvgTriangle as ReactComponent };
export default __webpack_public_path__ + "assets/icons/triangle.86eb62.svg";